module.exports = __webpack_public_path__ + "static/media/reportList.acf426df.svg";